import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import Advertisement from "./Advertisement";
import store from "../../common/store";
import {
  getPrivatePopup,
  getPublicPopup,
  ShowAdvertisement,
} from "../../common/actions/userActions";
import { isEmpty } from "../../common/cores";

const Popup = (props) => {
  const [showed, setShowed] = useState([]);
  const { popup, showAdvertisement, isAuthenticated } = props;

  const popupStr = localStorage.getItem("popup");
  const popups = !isEmpty(popupStr) ? JSON.parse(popupStr) : [];
  const popupExp = Number(localStorage.getItem("popupExp"));
  const date = new Date();

  const ToggleImage = (id) => {
    setTimeout(() => {
      const index = showed.findIndex((item) => item === id);
      if (index >= 0)
        setShowed(
          showed.slice(0, index).concat(showed.slice(index + 1, showed.length))
        );
      else setShowed([...showed, id]);
    }, 300);
  };

  const ShowAllAdvertisements = (auth) => {
    if (auth) {
      let popupItems = [];
      for (let i = 0; i < popup.length; i++) {
        if (
          popupExp >=
          Date.UTC(
            date.getUTCFullYear(),
            date.getUTCMonth() + 1,
            date.getUTCDate()
          )
        ) {
          if (isEmpty(popups.find((item) => item === popup[i]._id))) {
            popupItems.push(popup[i]._id);
          }
        } else {
          popupItems.push(popup[i]._id);
        }
      }
      setShowed(popupItems);
    }
  };

  useEffect(() => {
    if (showAdvertisement) {
      // console.log("팝업에서 내용", popup, showed, showAdvertisement)
      ShowAllAdvertisements(true);
      props.ShowAdvertisement(false);
    }
  }, [showAdvertisement]);

  // console.log("팝업에서 내용", popup, showed)

  useEffect(() => {
    // if(isAuthenticated){
    //   props.getPrivatePopup();
    // }
    // else{
    //   props.getPublicPopup();
    // }
    props.getPublicPopup();
  }, [isAuthenticated]);

  return (
    <Fragment>
      <div id="wrap" aria-hidden="true">
        <div
          className={`flexbox_popupadvertisement`}
          style={{
            justifyContent: showed.length > 4 ? "start" : "center",
            display: isEmpty(showed) ? "none" : "",
          }}
        >
          {popup.map((item, index) => {
            return (
              !(
                !isAuthenticated &&
                !isEmpty(popups.find((popupItem) => popupItem === item._id)) &&
                popupExp >=
                  Date.UTC(
                    date.getUTCFullYear(),
                    date.getUTCMonth() + 1,
                    date.getUTCDate()
                  )
              ) && (
                <Advertisement
                  key={index}
                  data={item}
                  showed={showed}
                  ToggleImage={ToggleImage}
                />
              )
            );
          })}
        </div>
      </div>

      <section
        id="popup"
        style={isEmpty(showed) ? { display: "none" } : { display: "block" }}
      ></section>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  showAdvertisement: state.user.showAdvertisement,
  popup: state.user.popup,
  isAuthenticated: state.user.isAuthenticated,
});

export default connect(mapStateToProps, {
  ShowAdvertisement,
  getPublicPopup,
  getPrivatePopup,
})(Popup);



// WEBPACK FOOTER //
// ./src/components/common/Popup.js